function setCookie (key, value, {
  path = '/',
  domain,
  maxAge,
  expires,
  secure
} = {}) {
  let cookieStr = key + '=' + encodeURIComponent(value)

  path && (cookieStr += ';path=' + path)
  domain && (cookieStr += ';domain=' + domain)
  maxAge && (cookieStr += ';max-age=' + maxAge)
  expires && (cookieStr += ';expires=' + expires.toUTCString())
  secure && (cookieStr += ';secure=' + secure)

  document.cookie = cookieStr
}

let shieldResultName = 'shieldResult'

// review-panel有问题咨询@计方玉
const DIV_ID = `show_panel_wrap_${Date.now()}`
const dispatchShieldEvent = (isSuccss) => {
  const shieldEvent = (isSuccess) => new CustomEvent(shieldResultName, {
    detail: { isSuccess }
  })
  if (window.dispatchEvent) {
    window.dispatchEvent(shieldEvent(isSuccss))
  } else {
    window.fireEvent(shieldEvent(isSuccss))
  }
}

const INIT_PARAM = {
  IFRAME_BOX_ID: DIV_ID,  // 验证码iframe的包裹id
  PANEL_THEME: 'default',   // 主题，可选值为embed、popup、xlx,default(自适应)默认是embed

  // 用户点击关闭按钮后的回调，业务可根据自身业务需要关闭验证面板等。
  // 工作量计算验证方式例外（自计算完成后直接关闭验证面板，难捕捉用户点击关闭按钮操作），可在“VERTIFY_SUCC_FUNC”函数中捕捉验证弹窗关闭
  CLOSE_PANEL_FUNC (data) {
    dispatchShieldEvent(false)
    document.getElementsByTagName('body')[0].removeChild(document.getElementById(DIV_ID))
  },

  // 回调，熊盾完成后会执行。data: { code:200, creditkey: 'xx' }
  VERTIFY_SUCC_FUNC (data) {
    if (data.code === 200 && data.creditkey !== '') {
      dispatchShieldEvent(true)
      setCookie('creditkey', data.creditkey, { domain: '.xunlei.com' })
      document.getElementsByTagName('body')[0].removeChild(document.getElementById(DIV_ID))
    }
  }
}

function completed () {
  try {
    window.XlCaptcha.init(INIT_PARAM)
  } catch (e) {
    document.getElementsByTagName('body')[0].removeChild(document.getElementById(DIV_ID))
  }
}

// 熊盾返回的链接
function showShield ({ reviewurl = '', creditkey = '' } = {}, namespace = 'shieldResult') {
  shieldResultName = namespace  // 保证触发的是最后一次的事件名
  if (creditkey) {
    setCookie('creditkey', creditkey, { domain: '.xunlei.com' })
  }

  if (reviewurl) {
    if (window.location.protocol === 'http:') {
      reviewurl = reviewurl.replace('https://', 'http://')
    }
    
    const div = document.createElement('div')
    div.id = DIV_ID
    div.style.cssText = 'width: 100%; height: 100%; position: fixed; top: 0; left: 0; z-index: 2;'

    const iframe = document.createElement('iframe')
    iframe.setAttribute('src', reviewurl)
    iframe.style.cssText = 'width: 406px; height: 466px; position: fixed; top: 50%; margin-top: -233px; left: 50%; margin-left: -203px; border: none;'

    iframe.onload = completed
    iframe.onreadystatechange = () => {
      if (iframe.readyState === 'complete') {
        completed()
      }
    }

    div.appendChild(iframe)

    document.getElementsByTagName('body')[0].appendChild(div)
  }
}

export { showShield }
